// Models
import { assessmentRegistrationModels } from './registration'
import { assessmentPlanningModels } from './planning'
import { assessmentPreparationModels } from './preparation'
import { createAssessmentStoreDefaultModel } from './assessment.store'
import { createAssessmentSupportDocumentStoreDefaultModel } from './assessment-support-document.store'
import { createAssessmentAnotherDocumentStoreDefaultModel } from './assessment-another-document.store'

const assessmentModels = {
  assessment: createAssessmentStoreDefaultModel(),
  assessmentSupportDocument: createAssessmentSupportDocumentStoreDefaultModel(),
  assessmentAnotherDocument: createAssessmentAnotherDocumentStoreDefaultModel(),
  ...assessmentRegistrationModels,
  ...assessmentPlanningModels,
  ...assessmentPreparationModels,
}

export { assessmentModels }
